import model from 'modules/buildingLevel2/buildingLevel2Model';

const { fields } = model;

export default [
  fields.name,
  fields.customers,
];
